import type { FaireProductEntity } from "../../entity_types/product";

export const p_h7rrd8z7s8: FaireProductEntity = {
  token: "p_h7rrd8z7s8",
  type: "product",
  name: "Trefl Red Desert Flowers 1000 Piece Puzzle",
  brandToken: "b_2gyr9m38qj",
  brandName: "Trefl USA",
  imageUrl:
    "https://cdn.faire.com/fastly/66bf657bfde223032cc0323bb8537938fe258ef66583867d83d25e54646beec6.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/d7b3c862394e60df7f177f236cf70bfb4f761ad3333877110952e67c1e277ba3.jpeg",
    "https://cdn.faire.com/fastly/040024b6cef09bd4d7e090d0aaf3d844debf52050d70facae871250aefb8781a.jpeg",
    "https://cdn.faire.com/fastly/400a80fe9076ad7b8747e790fa31a93c3ebc371ea3900b71eb286584eff81be7.jpeg",
    "https://cdn.faire.com/fastly/67582677a2ca8bc12e2e7765d1623e255c83e5a6de65910fd6ae03aaba081044.jpeg",
  ],
  priceDollars: 6.91,
  description:
    "Witness bloom season in the badlands. Cactus blossoms burst in scarlet and gold against rugged mesas. Linen finish and premium board lock in every petal’s pop.",
  tags: [],
  msrpDollars: 13.84,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T23:57:20.879Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
